import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import Button from "@components/Button/Button";
import { useLogout } from "@hooks/useLogout";
import { t } from "i18next";

const SettingsPage: React.FC = () => {
  const { logout } = useLogout();

  return (
    <div className="flex-column pt-8 pb-8 px-8">
      <Button
        type="button"
        variant="contained"
        color="primary"
        testId="logout-button"
        label={
          <span className="text-sm font-medium flex items-center gap-2">
            <LogoutIcon fontSize="small" />
            {t("common.logout")}
          </span>
        }
        sx={{ height: "40px", minHeight: "40px" }}
        onClick={() => logout()}
      />
    </div>
  );
};

export default SettingsPage;
